package com.rabbitsign.common

import kotlinx.serialization.Serializable

@Serializable
data class DocInfo(val url: String, val docTitle: String)